// Free gift banner access control: detect the special URL param once per session
(function() {
  if (!sessionStorage.getItem('freeGiftUnlocked')) {
    var params = new URLSearchParams(window.location.search);
    if (params.get('fg') === 'wij2026') {
      sessionStorage.setItem('freeGiftUnlocked', 'true');
    }
  }
})();